interface Constants {
  [label: string]: string;
}
const constants: Constants = {
  API_URL: process.env.REACT_APP_SERVER_URL || "",
  X_API_KEY: process.env.REACT_APP_X_API_KEY || "",
};

export default constants;
